import React from 'react'
import { Badge, BadgeProps } from '@chakra-ui/react'

export type RoleType = 'super' | 'admin' | 'editor' | 'viewer'

interface RoleBadgeProps extends Omit<BadgeProps, 'colorScheme'> {
  role: RoleType
  variant?: 'solid' | 'subtle' | 'outline'
}

const ROLE_COLOR_MAP: Record<RoleType, string> = {
  super: 'red',
  admin: 'purple',
  editor: 'blue',
  viewer: 'green',
}

const ROLE_DISPLAY_MAP: Record<RoleType, string> = {
  super: 'Super Admin',
  admin: 'Admin',
  editor: 'Editor',
  viewer: 'Viewer',
}

export default function RoleBadge({
  role,
  variant = 'subtle',
  children,
  ...props
}: RoleBadgeProps) {
  const colorScheme = ROLE_COLOR_MAP[role] || 'gray'
  const displayText = children || ROLE_DISPLAY_MAP[role] || role

  return (
    <Badge
      colorScheme={colorScheme}
      variant={variant}
      borderRadius="md"
      fontSize="xs"
      fontWeight="medium"
      textTransform="capitalize"
      {...props}
    >
      {displayText}
    </Badge>
  )
}

// Export constants for external use
export { ROLE_COLOR_MAP, ROLE_DISPLAY_MAP }
